import { CustomerContact } from '../types'
import { receivesBillingNotifications } from './contactPurposes'

export function getBillingContacts(
  contacts: Partial<CustomerContact>[]
): Partial<CustomerContact>[] {
  const billingContacts = contacts.filter(receivesBillingNotifications)

  return billingContacts
}
